module.exports = __webpack_public_path__ + "img/land-owners-hero-5a6c9dd.jpg";